import { Data } from "@toruslabs/http-helpers";

import config from "@/config";
import { setAccessToken } from "@/utils/accessToken";
import { logout } from "@/utils/utils";

import { authRequest, signedPost } from "../helpers/http";

const withRefreshRetryHandler = (request: () => Promise<unknown>) =>
  request().catch(async (e: { code: number }) => {
    if (e.code === 401) {
      try {
        const response = await signedPost(`${config.backendURL}/user/authenticate`, {}, {});
        const { token } = response as { token: string };
        setAccessToken(token);
        return request();
      } catch (err: unknown) {
        if ((err as { code: number }).code === 401) {
          logout();
          window.location.href = "/login";
        }
        throw e;
      }
    }
    throw e;
  });

export const authGet = (url: string, queryParams: Record<string, string>, options: RequestInit) =>
  withRefreshRetryHandler(() => authRequest("GET", url, queryParams, {}, options));
export const authPost = (url: string, data: Data, options: RequestInit) => withRefreshRetryHandler(() => authRequest("POST", url, {}, data, options));
export const authPut = (url: string, data: Data, options: RequestInit) => withRefreshRetryHandler(() => authRequest("PUT", url, {}, data, options));
export const authPatch = (url: string, data: Data, options: RequestInit) =>
  withRefreshRetryHandler(() => authRequest("PATCH", url, {}, data, options));
export const authDelete = (url: string, queryParams: Record<string, string>, options: RequestInit) =>
  withRefreshRetryHandler(() => authRequest("DELETE", url, queryParams, {}, options));
